import { gql } from "@apollo/client"

const GET_STAFF = gql`
  query (
    $searchTerm: String
    $page: Int!
    $perPage: Int!
    $clientId: ID!
    $orderBy: [ClientStaffOrderByOrderByClause!]
    $where: ClientStaffWhereWhereConditions
  ) {
    client(id: $clientId) {
      id

      staff(searchTerm: $searchTerm, page: $page, first: $perPage, orderBy: $orderBy, where: $where) {
        data {
          id
          salutation
          forename
          surname
          display_name
          reg_group
          is_teacher
          email
          user_id
          local_id
          data_ref
          is_sync
          no_of_lessons
          created_at
          updated_at

          user {
            id
            email
          }
        }

        paginatorInfo {
          total
          currentPage
          hasMorePages
          lastPage
          perPage
        }
      }
    }
  }
`

const GET_STAFF_LESSONS = gql`
  query ($id: ID!) {
    staffMember(id: $id) {
      id

      lessons(orderBy: [{ column: NAME, order: ASC }]) {
        id
        name
      }
    }
  }
`

export { GET_STAFF, GET_STAFF_LESSONS }
